class Sections {
  constructor() {
    this.fleetSections = [
      // { title: "Map", state: "fleet", icon: "map" },
      { title: "Buses", state: "buses", icon: "directions_bus" },
      { title: "Captains", state: "captains", icon: "person" },
      { title: "Contractors", state: "contractors", icon: "how_to_reg" },
      { title: "Companies", state: "companies", icon: "business" },
    ];

    this.routesSections = [
      {
        title: "Stations",
        state: "stations",
        icon: "transfer_within_a_station",
      },
      { title: "Stations Heatmap", state: "stationsheatmap", icon: "map" },
      { title: "Rides", state: "rides", icon: "directions_run" },
      { title: "Backups", state: "backups", icon: "backup" },
      {
        title: "Backup Schedule",
        state: "backupschedules",
        icon: "access_time",
      },
    ];

    this.customersSections = [
      { title: "Corporates", state: "corporates", icon: "business" },
      { title: "Ratings", state: "ratings", icon: "star_half" },
    ];

    this.bookingsSections = [
      { title: "Ratings", state: "ratings", icon: "star_half" },
      {
        title: "Pending Bookings",
        state: "pendingBookings",
        icon: "pending_actions",
      },
    ];

    this.settingsSections = [
      { title: "Cities", state: "cities", icon: "local_convenience_store" },
      { title: "Countries", state: "countries", icon: "flag" },
      { title: "Districts", state: "districts", icon: "line_weight" },
      {
        title: "Payment Methods",
        state: "paymentmethods",
        icon: "payments",
      },
      {
        title: "User Verifications",
        state: "userverifications",
        icon: "people",
      },
      { title: "Promotions", state: "promotions", icon: "fingerprint" },
      { title: "Events", state: "events", icon: "event" },
      {
        title: "Private Bus Requests",
        state: "privatebusrequests",
        icon: "airport_shuttle",
      },
      {
        title: "Special Requests Pricings",
        state: "pricings",
        icon: "monetization_on",
      },
      { title: "Bus Types", state: "bustypes", icon: "merge_type" },
      { title: "Topups", state: "topups", icon: "vertical_align_top" },
      { title: "Tickets", state: "tickets", icon: "linked_camera" },
      { title: "Loans", state: "loans", icon: "transform" },
      { title: "Tags", state: "tags", icon: "turned_in" },
      { title: "Holidays", state: "holidays", icon: "work" },
      {
        title: "Dispatcher Reports",
        state: "dispatchers",
        icon: "settings_input_component",
      },
      {
        title: "Upload Bulk Credits",
        state: "bulkcredits",
        icon: "monetization_on",
      },
      { title: "Authorization", state: "authorization", icon: "lock" },
      {
        title: "Corporate Transportation Submissions",
        state: "corporatetransportationsubmissions",
        icon: "meeting_room",
      },
      {
        title: "Manual Invoice Items",
        state: "manualinvoiceitems",
        icon: "library_books",
      },
      {
        title: "Captain App Versions",
        state: "captainappversions",
        icon: "code",
      },
      {
        title: "Corporate Contract Approvals",
        state: "corporatecontractapprovals",
        icon: "done_all",
      },
    ];

    this.plansSections = [
      { title: "Basic Plans", state: "basicplans", icon: "view_agenda" },
      { title: "Backup Plans", state: "backupplans", icon: "view_array" },
      { title: "Variable Plans", state: "variableplans", icon: "view_quilt" },
      {
        title: "Fulfillment Plans",
        state: "fulfillmentplans",
        icon: "vertical_split",
      },
      {
        title: "Supply Deduction Plans",
        state: "deductionplans",
        icon: "view_carousel",
      },
      { title: "Packages", state: "packages", icon: "local_offer" },
      { title: "Captain Plans", state: "captainfinance", icon: "line_weight" },
      { title: "Captain Invoices", state: "invoices", icon: "view_week" },
      {
        title: "Invoice Items",
        state: "invoiceitems",
        icon: "horizontal_split",
      },
      {
        title: "Fines Reimbursements",
        state: "finesreimbursements",
        icon: "money_off",
      },
    ];
  }
}

export default Sections;



// WEBPACK FOOTER //
// ./src/services/sections/sections.service.js